export const tableHeader = [
  { id: "name", type: "text", value: "Nome", sortable: true },
  { 
    id: "status", 
    type: "status-gap-analysis", 
    value: "Status", 
    sortable: true,
    render: (value) => {
      const getStatusColor = (status) => {
        const colors = {
          'Pendente': '#f59e0b', // Amarelo
          'Em Andamento': '#3b82f6', // Azul
          'Concluído': '#10b981', // Verde
          'Cancelado': '#ef4444', // Vermelho
          'Pausado': '#6b7280' // Cinza
        };
        return colors[status] || '#6b7280';
      };
      
      return (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ 
            width: '12px', 
            height: '12px', 
            borderRadius: '50%', 
            backgroundColor: getStatusColor(value),
            display: 'inline-block'
          }}></span>
          {value}
        </span>
      );
    }
  },
  { id: "date", type: "datetime", value: "Data", sortable: true },
  { id: "last_updated", type: "datetime", value: "Última Atualização", sortable: true },
  { id: "description", type: "text", value: "Descrição", sortable: true },
  { id: "action", type: "actions", value: "" },
];